<template>
  <div class="input_num">
    <button @click="minus">
      -
    </button>
    <input type="text" :value="counter_num" @change="inputChange">
    <button @click="plus">
      +
    </button>
  </div>
</template>
<script>
export default {
  props: {
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 0
    },
    value: {
      type: Number,
      default: 0
    }

  },
  data () {
    return {
      counter_num: this.value
    }
  },
  watch: {
    counter_num (newVal) {
      this.$emit('inputNo', newVal)
    }
  },
  methods: {
    setValue (value) {
      this.counter_num = value
    },
    inputChange (newVal) {
      console.log(this.max, this.min)
      let newValue = 0
      if (Number(newVal.target.value) > this.max) {
        newValue = this.max
      } else if (Number(newVal.target.value) < this.min) {
        newValue = this.min
      } else {
        newValue = Number(newVal.target.value)
      }
      this.counter_num = newValue.toFixed(2)
    },

    minus () {
      if (this.counter_num <= this.min + 1) {
        this.counter_num = this.min
      } else {
        this.counter_num--
      }
      this.counter_num = Number(this.counter_num).toFixed(2)
    },
    plus () {
      if (this.counter_num >= (this.max - 1)) {
        this.counter_num = this.max
      } else {
        this.counter_num++
      }
      this.counter_num = Number(this.counter_num).toFixed(2)
    }
  }
}
</script>
<style scoped>
.input_num {
  width: 135px;
  height: 34px;
  border-radius: 2px;
}
.input_num:hover {
  box-shadow: 0 0 0 0.5px #409eff;
}
.input_num > button {
  width: 25%;
  height: 100%;
  float: left;
  box-sizing: border-box;
  border: 1px solid #dcdfe6;
  outline: none;
  cursor: pointer;
  background: #f5f7fa;
  border-radius: 2px;
}
.input_num > button:active {
  background: #ffffff
}
.input_num > button:hover {
  color: #409eff
}
.input_num > input {
  width: 50%;
  height: 100%;
  float:left;
  box-sizing: border-box;
  outline: none;
  border:1px solid #dcdfe6;
  text-align:center;
  border-left:0;
  border-right:0;
  background:#fff
}
</style>
